import { useState } from "react";
import GuideBanner from "../components/GuideBanner";
import Tooltip from "../components/Tooltip";
import { PARTNER_STAGES, PARTNER_TYPES } from "../constants";

const ITEMS_PER_PAGE = 20;

export default function PartnerPipeline({ partners, setSelPartner }) {
  const [expandedStages, setExpandedStages] = useState({});

  const getVisibleCount = (stageId) => expandedStages[stageId] || ITEMS_PER_PAGE;
  const showMore = (stageId) => setExpandedStages((prev) => ({ ...prev, [stageId]: (prev[stageId] || ITEMS_PER_PAGE) + ITEMS_PER_PAGE }));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <GuideBanner
        title="Pipeline de Credenciamento"
        text="Acompanhe cada parceiro desde a identificação até a ativação na rede. Lembre: após 'Validação', repasse ao Suporte para treinamento e ativação no sistema."
      />
      <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 8 }}>
        {PARTNER_STAGES.filter((s) => !["recusado", "sem_interesse"].includes(s.id)).map((stage) => {
          const sp = partners.filter((p) => p.stage === stage.id);
          const visibleCount = getVisibleCount(stage.id);
          const visibleItems = sp.slice(0, visibleCount);
          const hasMore = sp.length > visibleCount;
          return (
            <div key={stage.id} style={{ minWidth: 200, flex: "0 0 200px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 4px", marginBottom: 6 }}>
                <div style={{ width: 8, height: 8, borderRadius: 2, background: stage.color }} />
                <span style={{ fontSize: 11, fontWeight: 700, color: "#1e293b" }}>{stage.label}</span>
                <span style={{ fontSize: 10, color: "#94a3b8", background: "#f1f5f9", padding: "1px 4px", borderRadius: 3 }}>{sp.length}</span>
                <Tooltip text={stage.help} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6, minHeight: 50, background: "#f8fafc", borderRadius: 8, padding: 5 }}>
                {visibleItems.map((p) => {
                  const type = PARTNER_TYPES.find((t) => t.id === p.type);
                  return (
                    <div key={p.id} style={{ background: "#fff", borderRadius: 7, padding: 10, border: "1px solid #e5e7eb", cursor: "pointer" }} onClick={() => setSelPartner(p)}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a" }}>{p.name}</div>
                      <div style={{ fontSize: 10, color: "#64748b", marginTop: 2 }}>{p.contact}</div>
                      <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 3 }}>{p.region}</div>
                    </div>
                  );
                })}
                {hasMore && (
                  <button onClick={() => showMore(stage.id)} style={{
                    padding: "6px 0", fontSize: 10, fontWeight: 600, color: "#7c3aed",
                    background: "none", border: "none", cursor: "pointer", textAlign: "center",
                  }}>
                    Ver mais ({sp.length - visibleCount} restantes)
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
